import { render } from "./TableApi.vue?vue&type=template&id=77a1f91a&scoped=true"
import script from "./TableApi.vue?vue&type=script&lang=js"
export * from "./TableApi.vue?vue&type=script&lang=js"

import "./TableApi.vue?vue&type=style&index=0&id=77a1f91a&scoped=true&lang=css"

import exportComponent from "/Users/rhylton/Sites/projeto-obras/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-77a1f91a"]])

export default __exports__